import { render, staticRenderFns } from "./FeatureRequests.vue?vue&type=template&id=705c7401&scoped=true&"
import script from "./FeatureRequests.vue?vue&type=script&lang=js&"
export * from "./FeatureRequests.vue?vue&type=script&lang=js&"
import style0 from "./FeatureRequests.vue?vue&type=style&index=0&id=705c7401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c7401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705c7401')) {
      api.createRecord('705c7401', component.options)
    } else {
      api.reload('705c7401', component.options)
    }
    module.hot.accept("./FeatureRequests.vue?vue&type=template&id=705c7401&scoped=true&", function () {
      api.rerender('705c7401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/FeatureRequests/FeatureRequests.vue"
export default component.exports